module.exports = __webpack_public_path__ + "static/010-slideshow-d3fc4f134578625428af06fb71282dc6.jpg";